import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ children, requireRole }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/cuenta/login" replace />;
  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/cuenta" replace />;
  }
  return children;
}

export function FullLoader() {
  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <i className="fas fa-spinner fa-spin" style={{ fontSize: 40, color: "#163680" }} />
    </div>
  );
}
